//env stage based constants
// const API_ROUTE_PREFIX =
// window.location.hostname.includes('local') ? `http://dev.wmms-query-service.walmart.net` : '/api';

let API_ROUTE_PREFIX: string;
API_ROUTE_PREFIX = "/api/help-center/v1"

// if (window.location.hostname.includes('local')) {
//   // API_ROUTE_PREFIX = `http://localhost:5000/api`
//   API_ROUTE_PREFIX = "/api/help-center"
// } else if (window.location.hostname.includes('dev')) {
//   API_ROUTE_PREFIX = "/api/help-center"
// } else if (window.location.hostname.includes('stage')) {
//   API_ROUTE_PREFIX = "https://stage.wmms-query-service.walmart.net"
// } else {
//   API_ROUTE_PREFIX = "https://prod.wmms-query-service.walmart.net"
// }

// URLS
export const URL_GEN_SEARCH = `${API_ROUTE_PREFIX}/generative-search`;
export const URL_QUERY_SEARCH_RESP = `${API_ROUTE_PREFIX}/query-response`;
export const URL_QUERY_FEEDBACK = `${API_ROUTE_PREFIX}/query-feedback`;
export const URL_UPDATE_RESPONSE_COPIED = `${API_ROUTE_PREFIX}/query-response-copied`;
export const URL_UPDATE_SOURCE_CLICKED = `${API_ROUTE_PREFIX}/query-response-source-clicked`;
export const URL_UPDATE_TICKET_RAISED = `${API_ROUTE_PREFIX}/query-response-ticket-raised`;
export const URL_CANOPUS_DOCUMENT = window.location.hostname.includes('local')
  ? 'http://127.0.0.1:5000/download'
  : '/download';
// CONSTANTS
export const SEARCH_DROPDOWN_OPTIONS = [
  'Does it matter what internet browser I use to perform tasks in WMMS?',
  'How is access for matters being handled in general?',
  'The State Bar License is a required field but the timekeeper I am adding is not an attorney. What should I do?',
  'What type of LEDES file will WMMS accept?',
  'How do I upload documents related to an invoice?',
  'Is it required to enter a timekeeper when creating an invoice?',
  'For international trademark work, all of the emails we send are saved in folders in Walmart’s Anaqua docket system.Will notes saved in the system also be saved in Anaqua?',
  'How are Walmart users made aware that Outside Counsel has made updates to a matter?',
  'Will it be the practice of our contacts at Walmart to save notes or messages that we add to a matter in e - WMMS or will they automatically be saved in the system?',
  'When adding a note to a matter, will I receive a copy of the note / message that I can keep on my end for my records?, How will I be able to view saved messages?',
  'How can I include an email from Microsoft Outlook within a matter?',
  'Will all existing users from my firm migrate to the new system?',
  'Why do I have matters in the system with no timekeepers assigned?',
  'How will current timekeeper rates be migrated to e - WMMS?',
];
export const feedbackTags = [
  {
    tag: 'Wrong information',
    definition:
      'Response is useful but missing important information or fails to fully address the query.',
  },
  {
    tag: 'Bad citation',
    definition: 'Link/citation is broken / outdated / irrelevant content.',
  },
  {
    tag: 'Incomplete answer',
    definition: 'Useful but did not fully address the query.',
  },
  {
    tag: 'Slow',
    definition: 'Correct but took too long to generate.',
  },
  //   {
  //     tag: "Irrelevant",
  //     definition:"Response does not directly address or relate to the query asked."
  //   },
  {
    tag: 'Too long',
    definition: 'Correct but lengthy / wordy.',
  },
];
interface CanopusDocMap {
  docType: string;
  uuid: string;
}
export let CANOPUS_DOCUMENT_MAP: CanopusDocMap[];
if (
  window.location.hostname.includes('dev') ||
  window.location.hostname.includes('local')
) {
  CANOPUS_DOCUMENT_MAP = [
    { docType: 'eWMMS_OCUserGuide', uuid: 'a39c70e6-5e67-4917-8b76-3af2b4c4dc1f' },
    { docType: 'eWMMS_EnterBudget_JobAid', uuid: '53430a26-501d-44e0-a091-1186b8052569' },
    {
      docType: 'eWMMS_Budget_NextSteps_JobAid',
      uuid: '4727a32e-3a7f-4b97-a9d3-cdaff6ea2e93',
    },
    {
      docType: 'eWMMS_MatterDocuments_JobAid',
      uuid: '3247a13e-dcf6-418d-a327-180507e97ddf',
    },
    {
      docType: 'eWMMS_AddNotesToAMatter_JobAid',
      uuid: '3f8e7d08-ee64-4b7f-9c7b-85cc3cbd04a7',
    },
    {
      docType: 'eWMMS_EnterAnInvoice_JobAid',
      uuid: 'f38fdded-9ffd-48f5-839d-b479fba85700',
    },
    { docType: 'eWMMS_InvoiceNextSteps', uuid: 'f34d0787-2558-4aad-b7ee-982de53715cb' },
    {
      docType: 'eWMMS_CreateNewUser_AdminOnly',
      uuid: 'd20617c8-6232-483b-bd06-89c76cb16439',
    },
    {
      docType: 'eWMMS_SubmitTK_Rate_AdminOnly',
      uuid: 'e1f2ab28-247a-46b2-a6ef-1407baa2c812',
    },
    {
      docType: 'eWMMS_SubmitUsersForMatter_JobAid',
      uuid: '48d8b09d-863a-4c6c-9382-ffefeef0c023',
    },
    {
      docType: 'eWMMS_UTBMS_Expenses_CodeList',
      uuid: '757fa48e-eb4a-402b-ad1e-0b4562057e4f',
    },
    {
      docType: 'eWMMS_UTBMS_Fees_CodeList',
      uuid: '873dea49-c010-458d-ad9e-c5781ee5ede3',
    },
    { docType: 'eWMMS_FAQ_Document', uuid: '7f4285cb-83be-4a57-8c93-d6f367ffff17' },
  ];
} else if (window.location.hostname.includes('stage')) {
  CANOPUS_DOCUMENT_MAP = [
    { docType: 'eWMMS_OCUserGuide', uuid: 'dc2afc67-70ed-4f77-af37-178b2cf31238' },
    { docType: 'eWMMS_EnterBudget_JobAid', uuid: '3d036c56-e0b2-4dc2-a04c-05cfaf0a5c9d' },
    {
      docType: 'eWMMS_Budget_NextSteps_JobAid',
      uuid: '6aafd207-695c-430a-968f-04476bfc9f4d',
    },
    {
      docType: 'eWMMS_MatterDocuments_JobAid',
      uuid: 'f93350bd-f365-4baa-9630-ca45af2e7b31',
    },
    {
      docType: 'eWMMS_AddNotesToAMatter_JobAid',
      uuid: '9740b58d-4d68-4558-bdd1-6272c3c24189',
    },
    {
      docType: 'eWMMS_EnterAnInvoice_JobAid',
      uuid: '2751ad96-38fd-4991-876f-45eb549de6f2',
    },
    { docType: 'eWMMS_InvoiceNextSteps', uuid: '90a030b0-8ccd-4e4a-9c0c-b60f96dd791d' },
    {
      docType: 'eWMMS_CreateNewUser_AdminOnly',
      uuid: 'a64248d4-876e-4ffe-9515-d8761d181ba5',
    },
    {
      docType: 'eWMMS_SubmitTK_Rate_AdminOnly',
      uuid: '8cc2b103-8013-48fa-9990-7607eb3177ba',
    },
    {
      docType: 'eWMMS_SubmitUsersForMatter_JobAid',
      uuid: '8ffe5fdb-b5ee-436c-9f9e-efe8c71653b0',
    },
    {
      docType: 'eWMMS_UTBMS_Expenses_CodeList',
      uuid: '033755f6-675b-4493-9707-857a6a0d8420',
    },
    {
      docType: 'eWMMS_UTBMS_Fees_CodeList',
      uuid: 'a53a0766-476b-40f6-8049-ec3aa817a37c',
    },
    { docType: 'eWMMS_FAQ_Document', uuid: 'a635dfc7-f125-45ec-a467-9f06b9c3134f' },
  ];
} else {
  CANOPUS_DOCUMENT_MAP = [
    { docType: 'eWMMS_OCUserGuide', uuid: '110b78c2-86a4-4e49-a2aa-aeda84ef136e' },
    { docType: 'eWMMS_EnterBudget_JobAid', uuid: '00b52e9d-56cc-459f-8c1c-f3b95b0ed9b9' },
    {
      docType: 'eWMMS_Budget_NextSteps_JobAid',
      uuid: '5a5f7794-53c7-43f8-a0f2-652c39884765',
    },
    {
      docType: 'eWMMS_MatterDocuments_JobAid',
      uuid: '35b0edce-be08-46b5-bea6-fa8d11975854',
    },
    {
      docType: 'eWMMS_AddNotesToAMatter_JobAid',
      uuid: 'f7d11cf9-f506-44d0-b4ee-12b4ff5c2667',
    },
    {
      docType: 'eWMMS_EnterAnInvoice_JobAid',
      uuid: '5d954e0b-dc46-4f79-96ee-5543007e829e',
    },
    { docType: 'eWMMS_InvoiceNextSteps', uuid: '113198cb-0943-4c92-b351-1000a6446864' },
    {
      docType: 'eWMMS_CreateNewUser_AdminOnly',
      uuid: '963ac9ee-f9d8-4a15-a733-f74872d33fad',
    },
    {
      docType: 'eWMMS_SubmitTK_Rate_AdminOnly',
      uuid: 'd8bbf5b8-4033-4ec7-8d3b-21f55cce52f2',
    },
    {
      docType: 'eWMMS_SubmitUsersForMatter_JobAid',
      uuid: 'a798fee2-04db-4b6d-90ec-85d6a98c7fbb',
    },
    {
      docType: 'eWMMS_UTBMS_Expenses_CodeList',
      uuid: 'a5cebad6-f795-4d09-b048-9e98e6ab760a',
    },
    {
      docType: 'eWMMS_UTBMS_Fees_CodeList',
      uuid: 'ac41b5d8-91e8-4cd3-84f5-d10821514ff4',
    },
    { docType: 'eWMMS_FAQ_Document', uuid: 'a2af3ef1-f28f-467c-9c53-ecdc8f2606d2' },
  ];
}
export const domain = 'eWMMS';
n